import { Sm } from './data/sm.es6';
import { Lg } from './data/lg.es6';
import { Box } from './data/box.es6';

const COLORS = [
    '0d59f6', // blu
    '5ed952', // grn
    'eba259', // orn
    'e56a83', // pnk
    '6452d9', // pur
    '00b9f5', // sky
    'ebf00c', // ylw
];

export default class Icon {
    constructor(stageWidth, stageHeight) {
        this.baseX = Math.random() * stageWidth;
        this.baseY = Math.random() * stageHeight;
        this.x = this.baseX;
        this.y = this.baseY;
        this.scale = Math.random() + 0.5;
        this.rotation = ((Math.random() * 2 - 1) * Math.PI) / 6;
        this.baseRotation = this.rotation;

        // アニメーション関連
        this.t = Math.random() * Math.PI * 2; // アニメーション進行用
        this.speed = Math.random() * 0.005;

        // カテゴリ選択
        const category = this._chooseCategory();
        let rawSvg;
        let widthBase;

        if (category === 'Sm') {
            rawSvg = Sm[Math.floor(Math.random() * Sm.length)];
            const color = COLORS[Math.floor(Math.random() * COLORS.length)];
            rawSvg = rawSvg.replace('#COLOR#', `#${color}`);
            widthBase = 20;
        } else if (category === 'Lg') {
            rawSvg = Lg[Math.floor(Math.random() * Lg.length)];
            widthBase = 60;
        } else {
            rawSvg = Box[Math.floor(Math.random() * Box.length)];
            widthBase = 120;
        }

        const encoded = encodeURIComponent(rawSvg).replace(/'/g, '%27').replace(/"/g, '%22');
        this.image = new Image();
        this.image.src = `data:image/svg+xml;charset=utf-8,${encoded}`;

        this.width = widthBase * this.scale;
        this.height = widthBase * this.scale;
        this.size = widthBase;
    }

    _chooseCategory() {
        const r = Math.random() * 10;

        if (r < 6) return 'Sm';
        if (r < 9) return 'Lg';
        return 'Box';
    }

    draw(ctx) {
        if (!this.image.complete) return;

        this._animate(); // 動きを加える

        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(this.rotation);
        ctx.scale(this.scale, this.scale);
        ctx.drawImage(this.image, -this.size / 2, -this.size / 2, this.size, this.size);
        ctx.restore();
    }

    _animate() {
        this.t += this.speed;
        this.y = this.baseY + Math.sin(this.t * 5) * 10;
    }

    isOverlap(other) {
        const margin = 5;
        return Math.abs(this.x - other.x) < (this.width + other.width) / 2 + margin && Math.abs(this.y - other.y) < (this.height + other.height) / 2 + margin;
    }
}
